import { render, staticRenderFns } from "./verify_email.vue?vue&type=template&id=2de0a5e8&"
import script from "./verify_email.vue?vue&type=script&lang=js&"
export * from "./verify_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports